import React from 'react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  Heart,
  CheckCircle,
  Clock,
  Bookmark,
  Filter,
} from 'lucide-react';

/**
 * Status Summary Cards Component
 * Displays a filter dropdown to filter camps by status (All Camps, Favorite, Booked, Considering).
 * Trigger: filter icon only on small devices, "Filter" button on large devices.
 */
const StatusSummaryCards = ({
  activeTab = 'all',
  onStatusClick,
  isLoading = false
}) => {
  const statusConfig = [
    { id: 'favorite', label: 'Favorite', icon: Heart },
    { id: 'booked', label: 'Booked', icon: CheckCircle },
    { id: 'considering', label: 'Considering', icon: Clock },
  ];

  const activeLabel = activeTab === 'all'
    ? 'All Camps'
    : (statusConfig.find((s) => s.id === activeTab)?.label ?? 'Filter');

  if (isLoading) {
    return (
      <div className="w-full -mx-1 px-1 py-1">
        <div className="h-9 w-20 md:w-24 rounded-md bg-gray-200 animate-pulse" />
      </div>
    );
  }

  return (
    <div className="w-full -mx-1 px-1 py-1">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            className="h-9 gap-2 border-gray-200 bg-white hover:bg-gray-50"
            disabled={isLoading}
          >
            <Filter className="h-4 w-4 shrink-0" />
            <span className="hidden md:inline">Filter: {activeLabel}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="min-w-[10rem]">
          <DropdownMenuRadioGroup value={activeTab} onValueChange={onStatusClick}>
            <DropdownMenuRadioItem value="all" className="gap-2">
              <Bookmark className="h-4 w-4" />
              All Camps
            </DropdownMenuRadioItem>
            {statusConfig.map((status) => {
              const IconComponent = status.icon;
              return (
                <DropdownMenuRadioItem key={status.id} value={status.id} className="gap-2">
                  <IconComponent className="h-4 w-4" />
                  {status.label}
                </DropdownMenuRadioItem>
              );
            })}
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default StatusSummaryCards;
